export function parseBoldText(text: string): React.ReactNode {
    // Split the text into parts by "**"
    const parts = text.split("**");

    // Transform the parts into an array of React nodes
    const nodes: React.ReactNode[] = parts.map((part, index) => {
        // Odd indices are bold
        if (index % 2 !== 0) {
            return <strong key={index}>{part}</strong>;
        }
        // Even indices are regular text
        return part;
    });

    // Enable this again, when sonner supports react components
    return <>{nodes}</>;
}
